module.exports = __webpack_public_path__ + "media/images/zapier-44aa06c2c65004250b09562666ffe808.svg";